export const ACTION_CODE = 'DEAL' + '_ORIGINS' + '_ACTION';
